__turbopack_context__.v({
  "primaryTabs": "styles-module__HuCrBq__primaryTabs",
  "tabsContainer": "styles-module__HuCrBq__tabsContainer",
  "tabsWrapper": "styles-module__HuCrBq__tabsWrapper",
  "wrapper": "styles-module__HuCrBq__wrapper",
});
